import React from 'react'

// styling and images
import './style.css';
import ricslogo from '../../assets/images/rics-logo.png';


function Header() {


    return (
        <>
        <div className='header-title'>

            <div className='header-logo'>
                <img src={ricslogo} alt='Rics Bread Logo'/>
            </div>

            <div className='locale'>
                <div className='button-div'>
                        <a href='mailto: ricsbreadkc@gmail.com' className='email link'>ricsbreadkc@gmail.com</a>
                    </div>
                   <div className='button-div'>
                        <a href='tel:7173928385' className='email link'>717-392-8385</a>
                    </div>
            </div>
        </div>
        {/* {mobileHeader()} */}
        </>
    )
};

export default Header;